import { cn } from '@/lib/utils'

interface Tab {
  id: string
  label: string
  count?: number
}

interface RecommendationEngineTabsProps {
  tabs: Tab[]
  activeTab: string
  onTabChange: (tabId: string) => void
}

export function RecommendationEngineTabs({
  tabs,
  activeTab,
  onTabChange,
}: RecommendationEngineTabsProps) {
  return (
    <div
      role="tablist"
      aria-label="Recommendation engine tabs"
      data-variant="prominent"
      className="bg-muted border-border flex flex-wrap gap-1 rounded-lg border p-1.5"
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              'rounded-md px-3 py-1.5 text-base transition-colors',
              isActive
                ? 'text-foreground font-semibold ring-1 ring-border'
                : 'text-muted-foreground hover:text-foreground font-medium',
            )}
          >
            {tab.label}
            {tab.count !== undefined && (
              <span
                className={cn(
                  'ml-1.5 rounded-full px-1.5 py-0.5 text-xs',
                  isActive
                    ? 'bg-primary/10 text-primary'
                    : 'bg-muted text-muted-foreground',
                )}
              >
                {tab.count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
